import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import JoditEditor from "jodit-react";
import "./EditBlog.css";

const EditBlog = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [content, setContent] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [existingThumbnail, setExistingThumbnail] = useState("");
  const [loading, setLoading] = useState(false);
  const editor = useRef(null);
  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch the blog data to populate the form
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/blogs/${id}`);
        const blog = response.data;
        setTitle(blog.title);
        setCategory(blog.category._id);
        setContent(blog.content);
        setExistingThumbnail(blog.thumbnail); // Save the existing thumbnail URL
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog:", error);
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  // Fetch all categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/categories/all`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("category", category);
    formData.append("content", content);
    if (thumbnail) {
      formData.append("thumbnail", thumbnail);
    }

    try {
      const response = await axios.put(`${API_URL}/api/blogs/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // console.log("Blog updated:", response.data);
      setLoading(false);
      navigate("/blog-list"); // Redirect to the blog list page
    } catch (error) {
      console.error("Error updating blog:", error);
      setLoading(false);
    }
  };

  // Handle cancel button click
  const handleCancel = () => {
    navigate("/blog-list"); // Navigate back to the blog list page
  };

  return (
    <div className="edit-blog">
      <h1>Edit Blog</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Thumbnail: current Existing thumbnail for this blog</label>
          {/* Display existing thumbnail if available */}
          {existingThumbnail && (
            <div className="existing-thumbnail">
              <img src={existingThumbnail} alt="Existing Thumbnail" />
            </div>
          )}
          <input
            type="file"
            onChange={(e) => setThumbnail(e.target.files[0])}
          />
        </div>
        <div>
          <label>Title:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="category-select">
          <label>Category:</label>
          <select
            className="category-dropdown"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">Select a category</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Content:</label>
          <JoditEditor
            ref={editor}
            value={content}
            onChange={(newContent) => setContent(newContent)}
          />
        </div>
        <div className="blogbuttons-container">
          <button className="editblog-button" type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Blog"}
          </button>
          <button
            type="button"
            onClick={handleCancel}
            className="cancelblog-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditBlog;
